import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import FilterTableProvider from 'shell/hooks/use-filter-table/provider';

export const initialValuesNumerators = {
  id: '',
  description: '',
  orders: {},
  page: 0,
  rowsPerPage: 10,
};

const PageNumerators = (): ReactElement => {
  return (
    <FilterTableProvider initialValues={initialValuesNumerators}>
      <Outlet />
    </FilterTableProvider>
  );
};

PageNumerators.displayName = 'Page numerators initializer component';

export default PageNumerators;
